"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
/**
 * Higher Order Function that connects a FiniteStateMachine with a Renderer (Component),
 * and causes the Component to render when state changes after a transition.
 *
 */
const DEPRECATEDConnectRenderer = (Component) => (machineType) => {
    const machine = new machineType();
    return class Connect extends React.Component {
        constructor(props) {
            super(props);
            this.subscribe = this.subscribe.bind(this);
        }
        componentDidMount() {
            this.subscribe();
        }
        componentWillUnmount() {
            this.subscribe();
        }
        subscribe() {
            machine.subscribe((state, associatedValue) => this.forceUpdate());
        }
        render() {
            return (React.createElement(Component, Object.assign({}, this.props, { machine: machine })));
        }
    };
};
exports.default = DEPRECATEDConnectRenderer;
//# sourceMappingURL=ConnectRenderer.js.map